import { Typography } from '@mui/material';
import { EDashboardWidgetTypes, type IDashboardWidgetProps } from '@sharedInterfaces/IDashboard';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import NotificationWidget from '@src/App/Components/Widgets/NotificationWidget';
import type { TWidgetDefinition } from '@src/App/Pages/DashboardPage/Dashboard/Dashboard';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

const NotificationDashboardWidget: React.FC<IDashboardWidgetProps<EDashboardWidgetTypes.notificationWidget>> = ({
    id,
    params,
    isEditing,
    onParamChange,
}) => {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).dashboard;

    if (isEditing)
        return (
            <>
                <Typography>{langStrings.noSettings}</Typography>
            </>
        );

    return <NotificationWidget />;
};

export const notificationDashboardWidgetDefinition = {
    type: EDashboardWidgetTypes.notificationWidget,
    render: NotificationDashboardWidget,
    overrideCardDesign: true,
    defaultParams: {},
} satisfies TWidgetDefinition;
